/*
 * @FilePath     : /fe-estrain-customer/src/config/interceptors/index.js
 * @Author       : LiYang
 * @Date         : 2021-12-07 14:34:00
 * @LastEditTime : 2021-12-07 14:42:04
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import transformRequest from './request'
import transformResponse from './respones'

export default {
  transformRequest,
  transformResponse,
}
